module.exports = __webpack_public_path__ + "img/qy (13).5b380326.jpg";